<template>
  <div>
    <div id="drawer-messages-chat" class="drawer drawer-right drawer-messages dw-xs-10 dw-sm-6 dw-md-6 fold" aria-labelledby="drawer-messages-chat" ref="drawer" >
      <div class="drawer-contents" v-click-outside="closeDrawer" >
        <div class="drawer-main">
          <div class="drawer-heading">
            <h3 class="drawer-title">
              Messages
              <a href="#drawer-messages-chat" data-toggle="drawer" aria-foldedopen="true" aria-controls="drawer-messages-chat" class="btn btn-default pull-right" @click="handleCloseThreadCallback" ref="closeButton" ><i class="fa fa-close"></i></a>
            </h3>
          </div>
          <div class="drawer-body">
            <thread-discussion/>
          </div>
          <div class="drawer-footer row" v-if="userHasAcceptedTerms || this.$userIsAdmin || adminThread">
            <form>
                <div class="textarea-container">
                  <textarea
                    name="message text field"
                    v-model="messageText"
                    type="text"
                    class="form-control m-b-xs"
                    placeholder="Type message here..."
                    ref="messageText"
                    @input="$emit('input', $event.target.messageText)"
                    @keyup.enter.stop.prevent="handleEnterKeyPress"
                    :disabled="!thread || !thread.active || (!userHasAcceptedTerms && !this.$userIsAdmin && !adminThread)"></textarea>
                  <span style="color: #a94442">{{ errors.first('message text field') }}</span>
                </div>
                <div class="button-container">
                  <button
                    class="btn btn-sm btn-info circle-btn inactive"
                    @click="handleSendMessageCallback"
                    :disabled="!thread || !thread.active || (!userHasAcceptedTerms && !this.$userIsAdmin && !adminThread) || messageSending"
                    type="button">
                    <i class="fa fa-send"></i>&nbsp;
                  </button>
                  <button
                    class="btn btn-sm btn-info circle-btn inactive"
                    @click="handleGetFileInputChat"
                    :disabled="!thread || !thread.active || (!userHasAcceptedTerms && !this.$userIsAdmin && !adminThread) || messageSending"
                    type="button">
                    <i class="fa fa-2x fa-paperclip"></i>&nbsp;
                    <input style="display: none;" ref="fileInputChat" type="file" multiple @change="this.handleAddBookingFiles">
                  </button>
                </div>
            </form>
            <div class="col-xs-12" v-if="typers.length > 1">
              <p >
                <span v-for="(typer, index) in typers" :key="typer.id">
                  {{typer.name}}<span v-if="index < typers.length - 1"> and </span>
                </span>
                <span>
                  are typing
                </span>
              </p>
            </div>
            <div class="col-xs-12" v-if="typers.length === 1">
              <p v-for="typer in typers" :key="typer.id">
                {{typer.name}} is typing
              </p>
            </div>
          </div>
        </div>
        <div class="drawer-sidebar hidden-xs">
          <thread-sidebar
            :booking_id="this.thread.booking.id"/>
        </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { handleServerErrors, fetchResourceScope } from 'mixins'
import { notify } from 'utils'
import { findIndex } from 'lodash'
import moment from 'moment'
import ThreadDiscussion from './ThreadDiscussion'
import ThreadSidebar from './ThreadSidebar'
import LazyLoading from 'codium-lazy-loading'
import { helpers } from 'mixins/messages'
import ClickOutside from 'vue-click-outside'
import { ChatTracker } from 'mixins/analytics'

import $ from 'jquery'

export default {
  mixins: [fetchResourceScope, handleServerErrors, helpers, ChatTracker],

  data () {
    return {
      messageText: '',
      search: '',
      fetchingThreads: false,
      canPublish: true,
      throttleTime: 500,
      channel: null
    }
  },

  components: {
    ThreadDiscussion,
    ThreadSidebar,
    LazyLoading
  },

  directives: {
    ClickOutside
  },

  computed: {
    ...mapState('message', ['thread', 'threads', 'pagination', 'unread_count', 'typers', 'sending']),
    ...mapState('clientConfig', ['client_config']),
    ...mapState('app', ['loading']),

    userHasAcceptedTerms () {
      if (this.thread) {
        let userIndex = findIndex(this.thread.participants, participant => participant.id === this.$user.id)
        if (userIndex !== -1) {
          return this.thread.participants[userIndex].terms_accepted
        }
      }

      return false
    },

    messageSending () {
      return this.sending
    }
  },

  watch: {
    messageText: {
      handler (newText, oldText) {
        if (this.canPublish) {
          this.$echo.private(this.client_config.slug + '.thread.' + this.thread.id)
            .whisper('UserTyping', {
              id: this.$user.id,
              name: this.$user.name
            })

          this.canPublish = false
          setTimeout(() => {
            this.canPublish = true
          }, this.throttleTime)
        }
      }
    }
  },

  methods: {
    ...mapActions('message', ['sendMessage', 'uploadFile', 'addMessage', 'removeMessage', 'updateMessage', 'clearThread', 'getUnreadCount', 'broadcastTyping']),
    ...mapActions('dashboard', ['addMessageDashboard']),
    ...mapActions('booking', ['addMessageBooking']),
    ...mapActions('booking/file', ['storeBookingFile', 'setFilesLoading', 'addFile']),

    handleEnterKeyPress (key) {
      if (!event.shiftKey) {
        this.handleSendMessageCallback()
      }
    },

    handleSendMessageCallback () {
      if (!this.messageSending) {
        return this.validateBeforeSubmit()
          .then(() => {
            let payload = {
              threadId: this.thread.id,
              text: this.messageText
            }
            // TODO run over how we are doing this - is there a better way
            let tempMessageId = Math.floor(Math.random() * 100000000)

            let message = {
              message: {
                created_at: moment(),
                id: tempMessageId,
                sender_image: this.$user.profile_image_url,
                type: 'text',
                text: this.messageText,
                thread_id: this.thread.id,
                updated_at: moment(),
                user: this.$user,
                user_id: this.$user.id,
                loading: true
              }
            }
            this.addMessage(message)
            this.addMessageBooking({ payload: message, userId: this.$user.id })
            this.addMessageDashboard({ payload: message, userId: this.$user.id })
            let oldMessageText = this.messageText
            this.messageText = ''
            return this.sendMessage(payload).then((response) => {
              this.updateMessage({payload: response.data, tempMessageId: tempMessageId})
              this.trackEvent(this.analytics.V2.ChatMessageSendEvent)
            }).catch((error) => {
              if (error.response.data.errors && error.response.data.errors.text[0]) {
                notify.error(error.response.data.errors.text[0])
              } else {
                notify.error('Unfortunately we could not send the message, please try again.')
              }
              this.removeMessage(tempMessageId)
              this.messageText = oldMessageText
            })
          })
          .catch(() => {
            $('html, body').animate({
              scrollTop: $('.has-error:visible:first').offset().top
            }, 500)
          })
      }
    },

    validateBeforeSubmit () {
      return Promise.all([
        this.$validator.validateAll().then((result) => {
          if (this.$userIsAdmin) {
            return Promise.resolve()
          }
          if (result) {
            return Promise.resolve()
          }
          notify.error('Could not send your message.')
          return Promise.reject(new Error('Validation has failed.'))
        })
      ])
    },

    handleGetUnreadCountCallback () {
      return this.getUnreadCount(this.queryParams)
        .catch(this.handleServerErrorsCallback)
    },

    /*
     * Opens the file input window
     *
     * @return void
     */
    handleGetFileInputChat () {
      this.$refs.fileInputChat.value = null
      this.$refs.fileInputChat.click()
    },

    handleAddBookingFiles ({ target: { files } }) {
      if (files.length !== 0) {
        for (let i = 0; i < files.length; i++) {
          if (files[i].size >= 15000000) {
            notify.error('Maximum file size is 15MB. Unable to upload file: ' + files[i].name)
          } else {
            let file = files[i]

            let payload = {
              threadId: this.thread.id,
              file: file
            }

            let tempMessageId = Math.floor(Math.random() * 100000000)

            let message = {
              message: {
                created_at: moment(),
                id: tempMessageId,
                sender_image: this.$user.profile_image_url,
                type: 'file',
                file: {
                  file_name: file.name
                },
                thread_id: this.thread.id,
                updated_at: moment(),
                user: this.$user,
                user_id: this.$user.id,
                loading: true
              }
            }

            this.addMessage(message)

            this.uploadFile(payload).then(response => {
              this.trackEvent(this.analytics.V2.ChatMessageFileAddEvent, {'fileType': file.type, 'fileName': file.name})
              const message = response.data

              this.updateMessage({payload: message, tempMessageId: tempMessageId})
              this.addMessageBooking({ payload: { message: message }, userId: this.$user.id })
              this.addMessageDashboard({ payload: { message: message }, userId: this.$user.id })
              this.addFile({ file: message.file })
            }).catch((error) => {
              if (error.response && error.response.data.errors && error.response.data.errors.text[0]) {
                notify.error(error.response.data.errors.text[0])
              } else {
                notify.error('Something went wrong uploading your file. Please try again.')
              }
              this.removeMessage(tempMessageId)
            })
          }
        }
      }
    },

    handleCloseThreadCallback () {
      this.clearThread(this.client_config.slug)
    },

    closeDrawer () {
      if (this.$refs.drawer.classList.contains('open')) {
        this.$refs.closeButton.click()
      }
    }
  }
}
</script>
